import SkuCardDescription from '@/components/common/cards/sku/SkuCardDescription';
import ConditionalLink from '@/components/common/ConditionalLink';
import LoadingComponent from '@/components/common/LoadingComponent';
import { LastActivitiesMobileCardProps } from '@/types/props/components';
import { getSkuMainImage, SkuMainImage } from '@/utilites/get-sku-main-image';
import Image from 'next/image';
import LastActivitiesStatusAndActionMobile from '../LastActivitiesStatusAndAction';
import LoadingImage from '@/components/common/LoadingImage';
import { useTranslation } from 'next-i18next';
export default function LastActivitiesMobileCard({
  product,
  slug,
  productMainImageUrl,
  productName,
}: LastActivitiesMobileCardProps) {
  const { t: tCommon } = useTranslation('common');
  return (
    <ConditionalLink disabled={product === null} href={`/${slug}`}>
      <div className="tw-flex tw-items-center tw-gap-[0.5rem]">
        <div className={'tw-w-16 tw-h-auto tw-flex tw-flex-shrink-0'}>
          <LoadingImage
            className="tw-w-[68px] tw-h-[68px]"
            loading={product === null}
          >
            <SkuMainImage
              src={getSkuMainImage(productMainImageUrl)}
              alt={productName || 'loading image....'}
              width="68"
              height="68"
              className="object-fit-contain border rounded p-2"
            />
          </LoadingImage>
        </div>
        <div className="tw-flex tw-flex-col tw-max-w-[250px] tw-text-ellipsis">
          <LoadingComponent loading={product === null} keepContainer={false}>
            <span className="tw-font-plusJakartaSans tw-font-semibold tw-text-sm tw-leading-[17.64px] tw-line-clamp-1">
              {productName}
            </span>
          </LoadingComponent>
          <LoadingComponent keepContainer={false} loading={product === null}>
            <span className="tw-mt-1 tw-text-slate-gray tw-font-medium tw-font-plusJakartaSans tw-text-xs tw-leading-[15.12px]">
              <SkuCardDescription IncludeVolumeInPercent={true} sku={product} />
            </span>
          </LoadingComponent>
        </div>
      </div>
      <div className="tw-flex tw-items-center tw-justify-end tw-whitespace-nowrap">
        <LastActivitiesStatusAndActionMobile
          status={product}
          tCommon={tCommon}
        />
      </div>
    </ConditionalLink>
  );
}
